const identityV3Url = `${window.__ENV__.BFF_URL}/identity/v3/member/token`;
const ssoTokenEndpoint = `${window.__ENV__.BFF_URL}/identity/v4/member/sso/token`;

/**
 * Exchange a token and return a partial member JWT
 * @param {Object} idToken - Token to be passed for mli-identity header
 * @param {string} entityId - entityId indicating SSO entity
 * @param {string} transactionId - transactionId to be passed for mli-session-correlation-id header
 */
export const getPartialJwt = async (idToken, entityId, transactionId) => {
    const headers = {
        'Content-Type': 'application/json',
        'mli-session-correlation-id': transactionId,
        'mli-channel': 'web',
        'mli-identity': idToken,
    };
    const method = 'POST';

    // Determine the appropriate token endpoint based on how member initially authenticated
    const isSso = Boolean(entityId);
    const tokenUrl = isSso ? ssoTokenEndpoint : identityV3Url;

    try {
        const jwtResponse = await fetch(tokenUrl, {
            method,
            headers,
        });

        const jwtResponseBody = await jwtResponse.json();

        if (!jwtResponse.ok) {
            const errorMessage = `getPartialJwt: HTTP error ${jwtResponse.status} - ${
                jwtResponse.statusText
            }. Error: ${JSON.stringify(jwtResponseBody)}`;
            throw new Error(errorMessage);
        }

        const partialJWT = jwtResponseBody['gb-authorization'];
        return partialJWT;
    } catch (error) {
        // If it's already our custom error, re-throw it
        if (error.message?.startsWith('getPartialJwt:')) {
            throw error;
        }

        throw new Error('getPartialJwt: Error occurred with calling partial token endpoint');
    }
};
